import { Component, OnInit} from '@angular/core';
import { Mode } from '../../form-guide/utility/enums/enums';
import { BsModalRef } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-popup-notification',
  styleUrls: ['./popup-notification.component.css'],
  templateUrl: './popup-notification.component.html',
})
export class PopupNotificationComponent implements OnInit {
  alertHeader: string;
  alertMode: string;
  alertMassage: string;
  navigationURL: string;
  backLableText: string;
  exitNavigationURL: string = 'home';
  enableRichText: boolean = false;
  enableNavigation: boolean = false;
  navigateOnExit: boolean = false;
  selectedMode: string;
  afterClosingFunc: Function = () =>{};

  constructor(public bsModalRef: BsModalRef, private route: Router) {}

  ngOnInit() {
  }


exit(){
  this.bsModalRef.hide();
  if (this.navigateOnExit) {
    // this.route.navigate(['/'+ this.exitNavigationURL],
    //{ queryParams: { usertype: this.commonService.GetParametersByName('usertype'), userid : this.commonService.GetParametersByName('userid')} });
    this.route.navigate(['/'+ this.exitNavigationURL]);
  }

  this.afterClosingFunc();
}


  close() {
    
    this.bsModalRef.hide();
    if (this.enableNavigation) {
      // this.route.navigate(['/' + this.navigationURL],
      // { queryParams: { usertype: this.commonService.GetParametersByName('usertype'), userid : this.commonService.GetParametersByName('userid')} });
      this.route.navigate(['/' + this.navigationURL]);
    }

    this.afterClosingFunc();
  }
}
